import { useRef, useState } from 'react';
import { fileSize } from 'components/misc/functions';
import { HugeiconsIcon } from '@hugeicons/react';
import { AttachmentIcon, Delete02Icon, PlusSignIcon } from '@hugeicons/core-free-icons';

function OtherDocsUpload({ setValue }) {
    const [files, setFiles] = useState([]);
    const inputRef = useRef(null);

    const handleAdd = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;
        const newFile = { id: Date.now(), file: selected };
        const updated = [...files, newFile];
        setFiles(updated);
        setValue(updated.map(f => f.file));
        e.target.value = '';
    };

    const handleRemove = (id) => {
        const updated = files.filter(f => f.id !== id);
        setFiles(updated);
        setValue(updated.map(f => f.file));
    };

    return (
        <div className="col-span-full space-y-2">
            {files.map((item) => (
                <div key={item.id} className="flex items-center gap-3 rounded-xl border border-gray-200 dark:border-white/[.08] bg-white dark:bg-gray-900 px-3 py-2.5">
                    <div className="w-8 h-8 rounded-lg bg-amber-50 dark:bg-amber-500/10 flex items-center justify-center shrink-0">
                        <HugeiconsIcon icon={AttachmentIcon} size={16} className="text-amber-600 dark:text-amber-400" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{item.file.name}</p>
                        <p className="text-xs text-gray-400 mt-0.5">{fileSize(item.file.size)}</p>
                    </div>
                    <button
                        type="button"
                        onClick={() => handleRemove(item.id)}
                        className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors shrink-0"
                        aria-label="Remove file"
                    >
                        <HugeiconsIcon icon={Delete02Icon} size={15} />
                    </button>
                </div>
            ))}

            <label className="flex items-center gap-2.5 rounded-xl border-2 border-dashed border-gray-200 dark:border-white/[.10] bg-gray-50/50 dark:bg-white/[.02] hover:border-amber-300 dark:hover:border-amber-500/40 hover:bg-amber-50/30 dark:hover:bg-amber-500/5 transition-all px-4 py-3 cursor-pointer">
                <HugeiconsIcon icon={PlusSignIcon} size={16} className="text-gray-400 dark:text-gray-500" />
                <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Add another file</span>
                <input
                    ref={inputRef}
                    type="file"
                    className="sr-only"
                    accept="image/*, .doc, .docx, .pdf"
                    onChange={handleAdd}
                />
            </label>
        </div>
    );
}

export default OtherDocsUpload;
